/*
 * @Author: your name
 * @Date: 2022-04-29 00:28:57
 * @LastEditTime: 2022-05-17 09:33:52
 * @LastEditors: wangxi ioswangxi@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /childrenwelfare_big_screen/src/assets/mapData/西工区 copy.js
 */
const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410304004',
            ext_path: '河南省 洛阳市 瀍河回族区 北窑街道',
            cid: '1',
            pid: '410304',
            name: '北窑街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.497991, 34.693367]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410304200',
            ext_path: '河南省 洛阳市 瀍河回族区 瀍河回族乡',
            cid: '2',
            pid: '410304',
            name: '瀍河回族乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.514877, 34.70609]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410304002',
            ext_path: '河南省 洛阳市 瀍河回族区 瀍西街道',
            cid: '3',
            pid: '410304',
            name: '瀍西街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.48364, 34.693719]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410304001',
            ext_path: '河南省 洛阳市 瀍河回族区 东关街道',
            cid: '4',
            pid: '410304',
            name: '东关街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.496887, 34.681341]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410304007',
            ext_path: '河南省 洛阳市 瀍河回族区 华林街道',
            cid: '5',
            pid: '410304',
            name: '华林街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.506289, 34.677556]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410304005',
            ext_path: '河南省 洛阳市 瀍河回族区 塔湾街道',
            cid: '6',
            pid: '410304',
            name: '塔湾街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.520935, 34.696744]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410304006',
            ext_path: '河南省 洛阳市 瀍河回族区 杨文街道',
            cid: '8',
            pid: '410304',
            name: '杨文街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.522243, 34.722148]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410304003',
            ext_path: '河南省 洛阳市 瀍河回族区 五股路街道',
            cid: '401',
            pid: '410304',
            name: '五股路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.481389, 34.701217]
        }
    }
];

export { d };
